<template>
  <div class="status-bg-color" :style="styles">
    <ion-icon :name="data.icon"></ion-icon>
    <div>
      {{ data.text }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'status',
  props: {
    data: {
      backgroundColor: {
        type: String,
      },
      text: {
        type: String,
        default: ''
      },
      icon: {
        required: true
      },
    }
  },
  computed: {
    styles() {
      return {
        backgroundColor: this.data.backgroundColor,
      }
    }
  }
}
</script>


<style scoped lang="scss">
  .status-bg-color {
    display: flex;
    justify-content: flex-start;
    border-radius: 10px;
    color: white;
    gap: 4px;
    font-size: 10px;
    align-items: center;
    flex-wrap: wrap;
    padding-left: 5px;
    height: 14px;
    width: 90px;
  }

</style>


// WEBPACK FOOTER //
// src/vue/views/components/status.vue